import { render, staticRenderFns } from "./productQueryTable.vue?vue&type=template&id=11988f94&"
import script from "./productQueryTable.vue?vue&type=script&lang=js&"
export * from "./productQueryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports